<template>
  <div>
    <div class="advance-search">
      <div class="block">
        <div class="block-content">
          <el-form :model="information" ref="informationForm">
            <div class="form-row">
              <el-form-item :label="$t('Select Hotel')" class="hotel-form" prop="hotel" required>
                <el-select v-model="information.hotel" :placeholder="$t('Please select a hotel')">
                  <template #prefix>
                    <i class="el-icon-date el-input__icon"></i>
                  </template>
                  <el-option v-for="(hotel,index) of hotels" :label="hotel.name" :value="hotel.code" :key="index"/>
                </el-select>
              </el-form-item>
              <el-form-item class="qty-control date-item" prop="Arrival" :label="$t('Arrival Date')" required>
                <el-date-picker
                  :placeholder="$t('Arrival Date')"
                  v-model="information.Arrival"
                  @change="arrivalDateChange"
                  @focus="arrivalDateFocus"
                  value-format="yyyy-MM-dd"
                  format="MM/dd/yyyy"
                  :picker-options="startTimeOptions"
                  style="width: 100%;"
                  :clearable="false"
                />
                <span class="format">{{ information.Arrival | dateFormat(that)}}</span>
              </el-form-item>
              <el-form-item class="qty-control date-item" prop="Departure" :label="$t('Departure Date')" required>
                <el-date-picker
                  :placeholder="$t('Departure Date')"
                  v-model="information.Departure"
                  format="MM/dd/yyyy"
                  value-format="yyyy-MM-dd"
                  :picker-options="endTimeOptions"
                  :default-value="defaultEndDay"
                  style="width: 100%;"
                  :clearable="false"
                />
                <span class="format">{{ information.Departure | dateFormat(that)}}</span>
              </el-form-item>
            </div>
            <div class="form-row">
              <el-form-item :label="$t('Rooms & Guests')" class="rooms-inputs" :class="{'show-guests':showGuests}">
                <div class="event-box" @click.stop="toggleGuests">
                  <el-input
                    readonly
                    prefix-icon="el-icon-present"
                    suffix-icon="el-icon-arrow-down"
                    :value="$t('{0}Rooms/{1}Adults,{2}Children',
                    [information.rooms,information.Adults,information.Children])"/>
                </div>
                <div class="input-group" v-show="showGuests" @click.stop>
                  <i class="el-icon-close" @click="showGuests=false" v-if="0"></i>
                  <el-form-item :label="$t('Rooms')+$t(':')">
                    <el-input-number :precision="0" @focus="toReadonly" v-model="information.rooms" :min="1" :max="9"
                                    label="Adults Per Room"/>
                  </el-form-item>
                  <el-form-item :label="$t('Adults Per Room')+$t(':')">
                    <span class="input-tips">({{ $t('Maximum 4 Guests per Room') }})</span>
                    <el-input-number :precision="0" @focus="toReadonly" @change="qtyFix" v-model="information.Adults"
                                    :min="1" :max="3"
                                    label="Adults Per Room"/>
                  </el-form-item>
                  <el-form-item :label="$t('Child Per Room')+$t(':')" class="child-form">
                    <span class="input-tips">({{ $t('Maximum 4 Guests per Room') }})</span>
                    <el-input-number :precision="0" @focus="toReadonly" v-model="information.Children" :min="0"
                                    :max="maxChild"
                                    label="Child Per Room"/>
                  </el-form-item>
                </div>
              </el-form-item>

              <el-form-item prop="Departure" :label="$t('Promotion Code')">
                <el-input
                  prefix-icon="el-icon-present"
                  v-model="information.Promotion"/>
              </el-form-item>
              <div class="el-form-item actions">
                <el-button onmouseover="this.opacity='1'" type="primary" class="action-search" @click.prevent="search">
                  {{ $t('SEARCH') }}
                </el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/util';
import {mapState} from 'vuex'

export default {
  name: 'AdvanceSearch',
  props: {},
  data() {
    return {
      information: {
        Arrival: '',
        Departure: '',
        Adults: 2,
        Children: 0,
        hotel: '',
        rooms: 1,
        Promotion: '',
        hotelName:'',
      },
      hotels: [],
      showGuests: false,
      showRooms: false,
      price_calendar: '',
      datepickerMounted: false,
      curYear: '',
      curMonth: '',
    }
  },
  methods: {
    /*
    * @method { Function } getInfos 获取信息通用方法
    * @param { String } url 请求地址
    * @param { String } dataKey 本地属性名
    * @param { String } resKey 远程属性名
    * @param { Object } data 请求配置信息
    * */
    getInfos(url, dataKey, resKey, data = {}) {
      return this.axios.get(url, data)
        .then((res) => {
            if (res.code === 200) {
              this[dataKey] = res.data[resKey]
            }
          }
        )
    },

    search() {
      const d = this.information
      const params = {
        arrival_date: d.Arrival,
        departure_date: d.Departure,
        rooms: d.rooms.toString(),
        adults: d.Adults.toString(),
        children: d.Children.toString(),
        hotel_code: d.hotel,
        skin: this.skin,
      }
      if (d.Promotion) {
        params.promotion_code = d.Promotion
      }
      const other = {
        group_by: this.$route.query.group_by || 'rate',
        lang: this.$route.query.lang,
        skin: this.skin
      }
      let query = Object.assign(params, other)
      if (JSON.stringify(query) === JSON.stringify(this.$route.query)) {
        this.$router.replace('/refresh')
        return
      }
      this.$refs.informationForm.validate((valid) => {
        if (valid) {
          this.$store.commit('stateChange', {k: 'SearchParams', v: params})
          this.$router.push({
            'name': 'SelectRoom',
             query,
          })
        }
      });
    },
    qtyControl(num, date) {
      //没有值时禁用
      if (!this.information[date]) {
        return
      }
      let yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      let newDay = new Date(util.dateArr(this.information[date]));
      newDay.setDate(newDay.getDate() + num);
      //禁止选今天之前的日期
      if (newDay.getTime() < yesterday.getTime()) {
        return;
      }
      //禁止起始日期小于结束日期
      if (date === 'Arrival' && newDay.getTime() >= new Date(util.dateArr(this.information.Departure)).getTime()) {
        return;
      }
      if (date === 'Departure' && newDay.getTime() <= new Date(util.dateArr(this.information.Arrival)).getTime()) {
        return;
      }

      this.information[date] = util.dateStr(newDay)
    },
    initData() {
      this.getInfos('/api/employee/info/hotels', 'hotels', 'hotels').then(
        () => {
          this.$store.commit('stateChange', {k: 'hotels', v: this.hotels})
          this.information.hotel = this.hotels[0]?.code
          if (this.$route.name === 'SelectRoom') {
            const data = this.$route.query;
            this.information.Adults = data.adults
            this.information.Arrival = data.arrival_date
            this.information.Children = data.children
            this.information.Departure = data.departure_date
            this.information.Promotion = data.promotion_code
            this.information.hotel = data.hotel_code
            this.information.rooms = data.rooms
            this.curYear = new Date(data.arrival_date).getFullYear()
            this.curMonth = new Date(data.arrival_date).getMonth() + 1
          }
        }
      );
    },
    getPriceCalendar() {
      this.loading = true
      this.axios.get(`/api/employee/info/calendar?month=${this.curYear + '-' + this.curMonth}&hotel_code=${this.information.hotel}`, {
      }).then(
        (res) => {
          if (res.code === 200) {
            this.price_calendar = res.data
            // 如果information.Arrival当天没有房间，Arrival跳转到第一个可选房间
            if(this.price_calendar[this.information.Arrival]?.price == '-1') {
              this.autoFindInitDay()
            }
          }
        }
      ).finally(() => {
        this.loading = false
      })
    },
    autoFindInitDay() {
      // 设置是否继续寻找并设置开始时间
      let isContinue = true
      Object.keys(this.price_calendar).map((priceItem, index) => {
        if(isContinue) {
          if(this.price_calendar[priceItem].price !== '-1') {
            this.information.Arrival = priceItem
            this.information.Departure = Object.keys(this.price_calendar)[index + 1]
            isContinue = false
          }
        }
      })
    },
    autoInputDay() {
      let date = new Date()
      //开业逻辑
      if (this.openDayActive && this.notOpening) {
        date = new Date(util.dateArr(this.notOpening))
      }
      this.information.Arrival = util.dateStr(date)
      this.curYear = date.getFullYear()
      this.curMonth = date.getMonth() + 1
      date.setDate(date.getDate() + 1)
      this.information.Departure = util.dateStr(date)
    },
    toReadonly(event) {
      event.target.setAttribute('readonly', 'readonly');
    },
    qtyFix(n) {
      if (n === 3 && this.information.Children) {
        this.information.Children = 0
      }
    },
    toggleRooms() {
      this.showRooms = !this.showRooms
    },
    toggleGuests() {
      this.showGuests = !this.showGuests
    },
    arrivalDateChange(e) {
      this.information.Departure = util.dateStr(new Date((new Date(e)).getTime() + 1 * 1000 * 60 * 60 * 24))
    },
    arrivalDateFocus() {
      this.datepickerMounted = true
    },
    calculateMonth(curYear, curMonth, year, month) {
      return (curYear-year)*12 + (curMonth-month)
    }
  },
  created() {
    this.initData()
    document.onclick = () => {
      if (this.$route.name === 'Home' || this.$route.name === 'SelectRoom') {
        this.showGuests = false
        this.showRooms = false
      }
    }
  },
  computed: {
    ...mapState(['gaData']),
    maxChild() {
      return this.information.Adults === 3 ? 0 : 2
    },
    //是否需要验证开业日期
    openDayActive() {
      return !this.$store.state.onceSubmit
    },
    curHotel() {
      return this.hotels.find(hotel => hotel.code === this.information.hotel);
    },
    notOpening() {
      let openDay = this.curHotel.opening_date
      if (new Date() > new Date(util.dateArr(openDay))) {
        openDay = false
      }
      return openDay
    },
    startTimeOptions() {
      return {
        disabledDate: (time) => {
          //今天之前的时间不能作为起始时间
          let yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);

          // 一年之后均不能选
          let nextYearDay = new Date()
          nextYearDay.setDate(nextYearDay.getDate() + 364)

          // price_calendar中price=-1不能选
          return time.getTime() < yesterday.getTime() || time.getTime() > nextYearDay.getTime() || this.price_calendar[util.dateStr(time)]?.price == '-1';
        }
      }
    },
    endTimeOptions() {
      return {
        disabledDate: (time) => {
          //今天之前的时间不能作为起始时间
          let yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);

          // 不得超过Arrival day+最大选择天数毫秒数
          let maxDay = (new Date(this.information.Arrival)).getTime() + this.curHotel.max_booking_days * 1000 * 60 * 60 * 24

          // price_calendar中price=-1不能选
          // || this.price_calendar[util.dateStr(time)]?.price == '-1'
          return time.getTime() < yesterday.getTime() || new Date(time) <= new Date(this.information.Arrival) || time.getTime() > maxDay;
        }
      }
    },
    defaultEndDay() {
      let day = ''
      if (this.information.Arrival) {
        day = this.information.Arrival
      }
      return day
    },
  },
  watch: {
    'information.hotel'() {
      if (this.$route.name === 'Home' && this.openDayActive) {
        this.autoInputDay()
        this.getPriceCalendar()
      } else if (this.$route.name === 'SelectRoom') {
        this.getPriceCalendar()
      }
    },
    datepickerMounted () {
      this.$nextTick(() => {
        // 获取当前日期年月
        let currentYear = new Date().getFullYear();
        let currentMonth = new Date().getMonth();
        // 上一个月按钮
        let prevBtn = document.querySelectorAll('.el-date-picker__header .el-icon-arrow-left')[0]
        // 下一个月按钮
        let nextBtn = document.querySelectorAll('.el-date-picker__header .el-icon-arrow-right')[0]

        // 初始化判断是否是当前年月，上一个月按钮显示状态保持一致
        if (currentYear * 12 + currentMonth + 1 >= this.curYear * 12 + this.curMonth) {
          prevBtn.style.display = 'none'
        } else {
          prevBtn.style.display = 'inline-block'
        }

        // 点击前一个月
        prevBtn.addEventListener('click',() => {
          nextBtn.style.display = 'inline-block'
          if(this.curMonth == 1) {
            this.curMonth = 12
            this.curYear -= 1
          } else {
            this.curMonth -= 1
          }
          let calculateMonth = this.calculateMonth(this.curYear, this.curMonth, currentYear, currentMonth)
          if(calculateMonth <= 1) {
            prevBtn.style.display = 'none'
          }
          this.getPriceCalendar()
        })
        // 点击下一个月
        nextBtn.addEventListener('click',() => {
          // 上一个月按钮显示
          prevBtn.style.display = 'inline-block'
          if(this.curMonth == 12) {
            this.curMonth = 1
            this.curYear += 1
          } else {
            this.curMonth += 1
          }
          let calculateMonth = this.calculateMonth(this.curYear, this.curMonth, currentYear, currentMonth)
          if(calculateMonth > 12) {
            nextBtn.style.display = 'none'
          }
          this.getPriceCalendar()
        })
      })
    }
  }
}
</script>

<style>
.el-date-picker__header-label {
	cursor: not-allowed;
	pointer-events: none;
}

.el-icon-d-arrow-left::before,
.el-icon-d-arrow-right::before {
  display: none;
}
</style>
